import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "@/lib/api";
import useSEO from "@/hooks/useSEO";
import { Reveal } from "@/components/ui-lux";
import { NotFound } from "@/pages/Misc";

export default function Landing() {
  const { slug } = useParams();
  const [p, setP] = useState(undefined);
  useEffect(() => { api.get(`/content/landing_pages/${slug}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [slug]);
  useSEO(p ? { title: p.seo_title || p.title, description: p.meta_description || p.subheadline, image: p.image } : {});
  if (p === null) return <NotFound />;
  if (!p) return <div className="min-h-screen" />;
  const Cta = () => (p.cta_url?.startsWith("http") ? <a href={p.cta_url} className="btn-gold" data-testid="landing-cta">{p.cta_label}</a> : <Link to={p.cta_url || "/contact"} className="btn-gold" data-testid="landing-cta">{p.cta_label}</Link>);
  return (
    <div data-testid="landing-page">
      <section className="pt-[116px] px-3 sm:px-6 lg:px-[8vw]">
        <div className="relative rounded-2xl overflow-hidden min-h-[600px] flex items-end">
          <img src={p.image} alt="" className="absolute inset-0 w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A1C55] via-[#0A1C55]/60 to-transparent" />
          <Reveal className="relative p-6 sm:p-12 max-w-3xl">
            <span className="eyebrow">{p.template}</span>
            <h1 className="h1">{p.headline}</h1>
            <p className="lead mt-5 !text-slate-100">{p.subheadline}</p>
            <div className="mt-8"><Cta /></div>
          </Reveal>
        </div>
      </section>
      <section className="container-x py-24 grid lg:grid-cols-2 gap-14">
        <p className="text-slate-300 text-lg leading-relaxed whitespace-pre-line">{p.body}</p>
        <ul className="space-y-5">
          {(p.bullets || []).map((b) => <li key={b} className="flex gap-4 font-serif text-2xl font-semibold tracking-tight text-white"><Check className="text-[#D4AF37] mt-1 shrink-0" />{b}</li>)}
        </ul>
      </section>
      <section className="bg-white text-black py-20 text-center">
        <h2 className="font-serif text-4xl sm:text-5xl font-semibold tracking-[-0.04em]">Ready to begin?</h2>
        <div className="mt-8 [&_a]:!bg-black [&_a]:!text-white"><Cta /></div>
      </section>
    </div>
  );
}
